import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {

        },
        token: "",
        // 基础设置
        baseConfig: {
            servicePhone: "",
            serviceQrCodeImg: "",
            productListFocus: [],
        },
    },
    mutations: {
        // 设置token
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        // 设置用户
        SET_USER: (state, user) => {
            state.user = user
        },
        // 设置基础配置
        SET_BASE_CONFIG: (state, config) => {
            state.baseConfig = config
        },
    },
    actions: {
        // // 用户登录
        // Login({commit}, info) {
        //     commit('SET_TOKEN', info.token);
        //     commit('SET_USER', info.user);
        // },
    }
})
